import React, { useEffect } from "react";
import { ExclamationCircle, InfoCircle } from "react-bootstrap-icons";
import "./InvalidAuthorizationLink.css";
import { useLocation, useNavigate } from "react-router-dom";

const InvalidAuthorizationLink = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state?.displayPage) {
      navigate("/login");
    }
  }, []);

  return (
    <div className="invalid-link-page text-start">
      <div className="invalid-link-card">
        <div className="invalid-link-icon">
          <ExclamationCircle size={42} />
        </div>

        <h1>Link Invalid or Expired</h1>

        <p className="invalid-link-description">
          We couldn't verify your payoff authorization link. It may be invalid,
          expired, or no longer available.
        </p>

        <div className="invalid-link-divider" />

        <div className="invalid-link-help">
          <InfoCircle size={22} />
          <div>
            <h3>What can you do?</h3>
            <p>
              Please open the original link provided in your email. If the issue
              persists, contact our support team for assistance.
            </p>
          </div>
        </div>

        <p className="invalid-link-footer">
          For your security, payoff authorization can only be accessed through a
          valid link.
        </p>
      </div>
    </div>
  );
};

export default InvalidAuthorizationLink;
